export const SubscriptionLevel = {
	FREE: 'free',
	PRO: 'pro',
	ENTERPRISE: 'enterprise'
} as const;

export const SINGLE_RESPONSIVE_CONTAINER_MIN_SIZE = {
	minWidth: 572,
	minHeight: 400,
} as const;

export const DOUBLE_RESPONSIVE_CONTAINER_MIN_SIZE = {
	minWidth: 572,
	minHeight: 260,
} as const;

type SubscriptionLevel = (typeof SubscriptionLevel)[keyof typeof SubscriptionLevel];

export default SubscriptionLevel;
